"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.theme = void 0;
var _Brand = _interopRequireDefault(require("./Brand"));
exports.theme = _Brand.default;
//# sourceMappingURL=index.js.map